module.exports = __webpack_public_path__ + "static/media/mobile_header.e7cb97cb.png";